import { useContext } from 'react';
import { PdfContext } from 'utils/context';
import CultureListTable from '../Tables/CultureListTable';
import { useTranslation } from 'react-i18next';

const CultureListConventional = () => {
  const { t } = useTranslation();
  const { cultures } = useContext(PdfContext);

  const numberOfRowPerTable = 10;
  let slicedCultureTable = [];

  const conventionalCultures = cultures.filter((culture) => !culture.isOrganic);

  for (let i = 0; i < conventionalCultures.length; i += numberOfRowPerTable) {
    slicedCultureTable.push(conventionalCultures.slice(i, i + numberOfRowPerTable));
  }

  return (
    <div>
      {slicedCultureTable.map((data, index) => (
        <CultureListTable
          key={index}
          truncatedCultures={data}
          messageDuplicate={index > 0 ? t('simulation.common.continued') : ''}
          isOrganic={false}
        />
      ))}
    </div>
  );
};

export default CultureListConventional;
